import React from 'react'

const Swatch = ({ label, color, value, onSelect }) => {
  const isSelected = value === label
  const style =
    label === 'andere'
      ? {
          background:
            'conic-gradient(from 200deg, #000 0deg, #555 60deg, #1e40af 120deg, #f97316 180deg, #facc15 240deg, #22c55e 300deg, #000 360deg)',
        }
      : { background: color }
  return (
    <button
      type="button"
      onClick={() => onSelect(label)}
      className={`flex flex-col items-center gap-1 px-1 py-[6px] rounded-xl ${
        isSelected ? 'bg-[#00a7ff] text-white shadow-md' : 'text-gray-800'
      }`}
    >
      <span className={`h-10 w-10 rounded-full border ${isSelected ? 'border-white' : 'border-gray-300'}`} style={style} />
      <span className={`text-xs ${isSelected ? 'text-white' : 'text-gray-800'}`}>{label}</span>
    </button>
  )
}

export default Swatch
